import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { languageService } from '@/services/language/language.service';

/**
 * State is the data that is stored in the store.
 */
interface UserPreferencesState {
    /**
     * The theme of the application.
     */
    sidebarCollapsed: boolean;
    /**
     * The locale of the application.
     */
    locale: string;
}

/**
 * Actions are the functions that can be used to update the state.
 */
interface UserPreferencesActions {
    /**
     * Set the theme of the application.
     * @param theme - The theme to set.
     */
    setSidebarCollapsed: (collapsed: boolean) => void;
}

/**
 * This store is used to store the user preferences.
 * Preferences are persisted in localStorage.
 */
export const useUserPreferencesStore = create(
    persist<UserPreferencesState & UserPreferencesActions>(
        (set) => ({
            sidebarCollapsed: false,
            locale: languageService.getCurrentLocale(),
            setSidebarCollapsed: (collapsed) => {
                set({ sidebarCollapsed: collapsed });
            },
        }),
        {
            name: 'user-preferences-mevivo-energy-meters-web',
            storage: createJSONStorage(() => localStorage),
        },
    ),
);
